import { createAction, props } from '@ngrx/store';
import { SortDirection } from '../../../core/enums/sort-direction';
import { PatientResult } from '../../models/patient-result';

export interface PatientResultsFilters {
  searchTerm: string | null;
  abnormalTypeId: number | null;
  labResultStatusTypeId: number | null;
  sortDirection: SortDirection;
  sortColumn: string;
}

export const getPatientResults = createAction(
  '[Patient Result] Get Patient Results',
  props<{ filters: PatientResultsFilters }>()
);

export const getPatientResultsSuccess = createAction(
  '[Patient Result] Get Patient Results Success',
  props<{
    patientResults: PatientResult[];
    pageNumber: number;
    isAtEndOfData: boolean;
    totalRecordCount: number;
  }>()
);

export const getPatientResultsFailure = createAction(
  '[Patient Result] Get Patient Results Failure',
  props<{ error: unknown }>()
);

export const nextPage = createAction('[Patient Result] Next Page', props<{ pageNumber: number }>());

/**
 * Re-request the page that just failed, without touching `pageNumber` or the loaded entities.
 *
 * Distinct from `getPatientResults` (which `removeAll`s and restarts at page 1) so the inline error
 * retry does not throw away pages the patient has already scrolled through. The effect resolves the
 * page from the store, so leaving `pageNumber` alone is what makes this refetch the same page.
 */
export const retryPage = createAction('[Patient Result] Retry Page');

export const getPatientResultsById = createAction(
  '[Patient Result] Get Patient Results By Id',
  props<{ patientLabResultId: number }>()
);

export const getPatientResultsByIdSuccess = createAction(
  '[Patient Result] Get Patient Results By Id Success',
  props<{ patientResult: PatientResult }>()
);

export const getPatientResultsByIdFailure = createAction(
  '[Patient Result] Get Patient Results By Id Failure',
  props<{ error: unknown }>()
);

// Snapshot the list scroll position + last-opened row so we can restore them
// when the user returns from a result detail. Acts as a one-shot trigger:
// it's cleared once consumed on the next list mount.
export const rememberListPosition = createAction(
  '[Patient Result] Remember List Position',
  props<{ lastViewedResultId: number; scrollTop: number }>()
);

export const clearListPosition = createAction('[Patient Result] Clear List Position');

export const markAllAsReadSuccess = createAction('[Patient Result] Mark All As Read Success');

export const markAllAsReadFailure = createAction(
  '[Patient Result] Mark All As Read Failure',
  props<{ error: unknown }>()
);
